import { collection, getDocs, limit, query, where } from 'firebase/firestore';
import { db } from '../../../config/firebase.config';
import type { NamedImageItem } from '../types/detailsCard.types';

function normalizeWikidataTag(input: string): string {
  const trimmed = String(input || '').trim().toUpperCase();
  return /^Q\d+$/.test(trimmed) ? trimmed : '';
}

function extractItems(data: any): NamedImageItem[] {
  if (Array.isArray(data?.topSightsImages?.items)) return data.topSightsImages.items;
  if (Array.isArray(data?.topSightsImages)) return data.topSightsImages;
  if (Array.isArray(data?.items)) return data.items;
  return [];
}

function selectItemsFromSnapshot(snap: any): NamedImageItem[] | null {
  if (!snap || snap.empty) return null;

  let firstNonEmpty: NamedImageItem[] | null = null;
  snap.forEach((docSnap: any) => {
    if (firstNonEmpty) return;
    const data: any = docSnap.data() || {};
    const items = extractItems(data);
    if (items.length) firstNonEmpty = items;
  });

  return firstNonEmpty;
}

export async function loadPrecomputedTopSightsByWikidataTag(params: {
  wikidataTag: string;
}): Promise<NamedImageItem[] | null> {
  const wikidataTag = normalizeWikidataTag(params?.wikidataTag || '');
  if (!wikidataTag) return null;

  const primaryQuery = query(
    collection(db, 'precomputedTopSights'),
    where('city.wikidataTag', '==', wikidataTag),
    limit(5),
  );

  const primarySnap = await getDocs(primaryQuery);
  const primaryItems = selectItemsFromSnapshot(primarySnap);
  if (primaryItems) return primaryItems;

  // Legacy fallback for datasets with root-level wikidataTag.
  const legacyQuery = query(
    collection(db, 'precomputedTopSights'),
    where('wikidataTag', '==', wikidataTag),
    limit(5),
  );

  const legacySnap = await getDocs(legacyQuery);
  return selectItemsFromSnapshot(legacySnap);
}
